import { useCallback } from 'react';
import { generatePath, useHistory } from 'react-router-dom';

import { URLS } from 'config';
import { useCurrentJob } from 'hooks';

export interface DekstopHook {
  onClick: () => void;
}

export default function useDekstop(): DekstopHook {
  const { job } = useCurrentJob();
  const { push } = useHistory();

  const onClick = useCallback(() => {
    const id = job?.id;
    if (!id) return;
    push(generatePath(URLS.job, { id }));
  }, [job, push]);

  return {
    onClick,
  };
}
